import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { ControlCardVm } from '../../Models/ControlCardVm';
import { GetStatusVm,GetStatusId,  GetStatusName } from '../../components/HelperComponents/StatusHelper';
import { DateFormatter } from '../../components/HelperComponents/DateFormatter'
import { filterCardStatuses, filterCardStatusesPoliceKontrolKort } from '../../components/HelperComponents/FilterCardStatuses.js';
import { ValidationType } from '../../Constants/ValidationTypes';
import { cardNumberFromHRef } from '../../components/HelperComponents/GetCardNumberFromHRef.js';
import URL from '../../Constants/URL.js'

type Props = {};

type State = {
  showSpinner: boolean,
  showStatusChange: boolean,
  newCardStatusId: number,
  cardNumberInput: string,
  cardNumberIsValid: boolean,
  searchButtonPressed: boolean,
  cardFound: boolean,
  controlCardVm: ControlCardVm,
};

export default class SearchControlCard extends Component<Props, State> {
  static displayName = SearchControlCard.name;
  private toastRef: React.RefObject<any>;
  private baseState: State;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      showSpinner: false,
      showStatusChange: false,
      newCardStatusId: 0,
      cardNumberInput: "DK",
      cardNumberIsValid: false,
      searchButtonPressed: false,
      cardFound: false,
      controlCardVm: new ControlCardVm(),
    };
    this.baseState = this.state;
  }

  componentDidMount() {
    this.setState({ cardNumberInput: cardNumberFromHRef() }, () => {
      if (this.state.cardNumberInput.length === 16) {
        this.fetchControlCard()
      }
    })
  }

  fetchControlCard() {
    this.setState({ searchButtonPressed: true }, () => {
      if (this.state.cardNumberIsValid) {
        this.setState({ showSpinner: true })
        this.clearPage(false);
        fetchModel("GET", URL + "/api/controlcard/GetOldControlCard", this.state.cardNumberInput, ControlCardVm)
          .then(model => {
            this.setState({ controlCardVm: model[0], cardFound: true })
          })
          .catch(error => this.showErrorToast(error))
          .finally(() => this.setState({ showSpinner: false }))
      }
    })
  }

  clearPage(clearInput: boolean) {
    if (clearInput) {
      this.setState(this.baseState)
    } else {
      this.setState({
        cardFound: false,
        showSpinner: false,
        showStatusChange: false,
        newCardStatusId: 0,
        controlCardVm: new ControlCardVm(),
      })
    }
  }

  showErrorToast(error: string) {
    if (error === "No result") {
      this.toastRef.current.show("Kontrolkort", "Der findes ikke et gammelt kontrolkort på det søgte kortnummer", "warning")
    }
    else if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  changeCardStatus() {
    let model = Object.assign({}, this.state.controlCardVm);
    model.Status = GetStatusVm(this.state.newCardStatusId)

    let requestInfo = {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(model)
    }

    let success = true;

    fetch(URL + "/api/controlcard/ChangeCardStatus", requestInfo)
      .then(response => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false
        }
        this.fetchControlCard();
      })
      .catch(() => {
        success = false;
      })
      .finally(
        () => {
          success ? this.toastRef.current.show("Skift status", "Kortets status er skiftet.", "success")
            : this.toastRef.current.show("Skift status", "Kortets status blev ikke skiftet.", "error")
        }
      )
  }

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Segment
          title="Søg Kontrolkort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage(true) }}
            />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Angiv kortnummer"
        >
          <Fstyr.Input
            value={this.state.cardNumberInput}
            label="Kortnummer"
            onChange={(value: string) => this.setState({ cardNumberInput: value })}
            validation={true}
            validationType={ValidationType.cardNumber}
            errorBodyText={"Forkert format (landekode + 14 tegn)"}
            errorExampleText={"f.eks. DK00000050121001"}
            onEnterPressed={() => this.fetchControlCard()}
            setValid={(valid: boolean) => this.setState({ cardNumberIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />

          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => this.fetchControlCard()}
              disabled={this.state.showSpinner}
            />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment
          title="Kontrolkortinformation"
        >

          <div className="fstyr-attention-box">
            <Fstyr.Input
              label="Kortnummer"
              readonly={true}
              value={this.state.controlCardVm.CardNumber}
              direction="row"
            />
            <Fstyr.Input
              label="Kortejer (myndighed)"
              readonly={true}
              value={this.state.cardFound ? this.state.controlCardVm.CardOwnerName : ""}
              direction="row"
            />
            <Fstyr.Input
              label="Kortejer adresse"
              readonly={true}
              value={this.state.cardFound ? this.state.controlCardVm.CardOwnerAddress : ""}
              direction="row"
            />
            <Fstyr.Input
              label="Gyldighedsperiode"
              readonly={true}
              value={this.state.cardFound ? DateFormatter(this.state.controlCardVm.ValidFrom) + " - " + DateFormatter(this.state.controlCardVm.ValidTo) : ""}
              direction="row"
            />
            <Fstyr.Input
              label="Status på kort"
              direction="row"
              readonly={true}
              value={this.state.cardFound ? GetStatusName(this.state.controlCardVm.Status.Id) : ""}
            />
            <Fstyr.Button
              label="Skift status"
              disabled={!this.state.cardFound}
              onClick={() => { this.setState({ showStatusChange: true }) }}
            />

            {this.state.showStatusChange &&
              <div className="alert alert-info" style={{ marginTop: 10, maxWidth: 340 }}>
                <div className="alert-body" style={{ height: "100%" }}>
                  <p className="alert-heading">Ekstra oplysninger</p>
                  <p className="alert-text">Udfyld de nedenstående oplysninger.</p>
                  <Fstyr.Dropdown
                    items={global.config.isPolice ? filterCardStatusesPoliceKontrolKort(require('../../assets/CardStatus.json')) : filterCardStatuses(require('../../assets/CardStatus.json'))}
                    width={"100%"}
                    onItemSelected={(status) => this.setState({ newCardStatusId: GetStatusId(require('../../assets/CardStatus.json'), status) })}
                    label="Ny status"
                  />
                  <Fstyr.Input
                    label="Dato for ændring"
                    direction="column"
                    readonly={true}
                    value={DateFormatter(new Date())}
                  />
                  <div className='fstyr-right-button-group' >
                    <Fstyr.Button
                      label="Gem"
                      onClick={() => { this.changeCardStatus() }}
                      disabled={this.state.newCardStatusId === this.baseState.newCardStatusId}
                    />
                    <Fstyr.Button
                      label="Annullér"
                      type="secondary"
                      onClick={() => this.setState({
                        showStatusChange: false,
                        newCardStatusId: 0
                      })}
                    />
                  </div>
                </div>
              </div>
            }
          </div>
        </Fstyr.Segment>
      </>
    );
  }
}